import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject, interval } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GuideStep } from "../guide-step.model";
import { GuideService } from "../guide.service";

const PRESENCE_CHECK_INTERVAL_MS = 500;

export type GuideArrowSide = "top" | "bottom" | "left" | "right";

/**
 * Conteúdo do balão de instrução exibido dentro do overlay. Componente fino: injeta `GuideService`
 * direto (é singleton `root`) em vez de receber callbacks por `@Output`, e não conhece `OverlayRef` —
 * quem cuida de posicionamento/descarte do overlay é o `GuideOverlayService`.
 */
@Component({
  selector: "app-guide-overlay",
  templateUrl: "./guide-overlay.component.html",
  styleUrls: ["./guide-overlay.component.scss"],
})
export class GuideOverlayComponent implements OnInit, OnDestroy {
  @Input() step!: GuideStep;
  @Input() targetElement!: Element;

  arrowSide: GuideArrowSide = "top";

  private readonly destroy$ = new Subject<void>();

  constructor(private readonly guideService: GuideService) {}

  ngOnInit(): void {
    // O elemento-alvo pode sumir do DOM enquanto o passo está aberto (ex.: uma ação da própria tela
    // remove/recria o elemento); sem essa checagem, o overlay ficaria "órfão" apontando para o nada.
    interval(PRESENCE_CHECK_INTERVAL_MS)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (!document.body.contains(this.targetElement)) {
          this.guideService.skip();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNext(): void {
    this.guideService.next();
  }

  onPrevious(): void {
    this.guideService.previous();
  }

  onSkip(): void {
    this.guideService.skip();
  }
}
